import { ComponentCTALink } from 'components/landing/display'
import SimpleAnchor from 'components/display/SimpleAnchor'

export const testimonials = [
  {
    name: 'Jacob Stammers',
    affiliation: {
      text: 'The Barn at Heathcote',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/jacob_stammers.jpg',
    },
    text: 'Riparide guests seem to be chilled humans who understand the quirks of our property and really embrace the experience!',
    CTA: (
      <ComponentCTALink url="/stories/92-barn-country">
        View Story
      </ComponentCTALink>
    ),
  },
  {
    name: 'Andy Matenson',
    affiliation: {
      text: 'The Water Cabin',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/andy_matenson.jpg',
    },
    text: 'The Riparide site is very user-friendly and their fees are transparent and very reasonable for both host and guest.',
    CTA: (
      <ComponentCTALink url="/stories/727-serenity-by-the-water">
        View Story
      </ComponentCTALink>
    ),
  },
  {
    name: 'Fay Bushby',
    affiliation: {
      text: 'Bushies Love Shack',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/fay_bushby.jpg',
    },
    text: 'The Riparide team are so helpful and for someone who is computer illiterate, I find their platform very easy to use. I couldn’t recommend them more!',
    CTA: (
      <ComponentCTALink url="/stories/575-lovers-getaway">
        View Story
      </ComponentCTALink>
    ),
  },
  {
    name: 'Barry & Christine',
    affiliation: {
      text: 'The Canvas Barn B&B',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/barry_and_christina.jpg',
    },
    text: 'Doing stories about our property has proved to be very beneficial to our booking numbers - the majority of our bookings are now through Riparide.',
    CTA: (
      <ComponentCTALink url="/stories/401-cosy-in-warburton">
        View Story
      </ComponentCTALink>
    ),
  },
  {
    name: 'Lisa Deppeler',
    affiliation: {
      text: 'Aire River Escape',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/lisa_deppeler.jpg',
    },
    text: ' I like the idea that I am providing a unique experience and adventure for young people who need to get out of the city and do something different.',
    CTA: (
      <ComponentCTALink url="/stories/91-the-aire-down-there">
        View Story
      </ComponentCTALink>
    ),
  },
]

export const faqs = [
  {
    title: 'What kind of properties can I list?',
    content: (
      <>
        We’re looking for unique accommodation in non-urban areas with beautiful
        nature and outdoor activities nearby. See our{' '}
        <SimpleAnchor
          href="http://help.riparide.com/en/articles/5765492-listing-criteria"
          textDecoration="none"
        >
          listing criteria
        </SimpleAnchor>{' '}
        for more details and our locations.
      </>
    ),
  },
  {
    title: 'What are your fees?',
    content:
      'We charge nothing to list with us. Our Host service fee is 2% and our customer service fee is 14.5%. Depending on your location, you can choose to cover the customer fee as well to simplify your pricing.',
  },
  {
    title: 'Can I be listed on other accommodation sites too?',
    content:
      'Of course! While we’d love you to be exclusively Riparide, we know that isn’t always an option. To help you manage your bookings across multiple platforms, we can easily sync your calendars.',
  },
  {
    title:
      'I’m already fully booked on another site - why should I list with Riparide?',
    content:
      'Good question. The answer? We have lower fees, we’re locally-minded and we only work with rad people who share our values. Give us a chance to get you fully booked with Riparide instead!',
  },
]
